import type { AiToneAndVoiceSettingsUpdate } from "@redotech/redo-concierge-settings-common/ai-tone-and-voice";

export type AiToneSliderKey = keyof Pick<
  AiToneAndVoiceSettingsUpdate,
  | "formalityCasualness"
  | "seriousnessHumor"
  | "respectfulnessIrreverence"
  | "matterOfFactEnthusiasm"
>;

export const aiToneSliderConfig: {
  key: AiToneSliderKey;
  label: string;
  leftLabel: string;
  rightLabel: string;
}[] = [
  {
    key: "formalityCasualness",
    label: "Formality",
    leftLabel: "Formal",
    rightLabel: "Casual",
  },
  {
    key: "seriousnessHumor",
    label: "Humor",
    leftLabel: "Serious",
    rightLabel: "Funny",
  },
  {
    key: "respectfulnessIrreverence",
    label: "Reverence",
    leftLabel: "Respectful",
    rightLabel: "Irreverent",
  },
  {
    key: "matterOfFactEnthusiasm",
    label: "Energy",
    leftLabel: "Matter-of-fact",
    rightLabel: "Enthusiastic",
  },
];
